/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import HomeIcon from '@material-ui/icons/HomeOutlined'
import PeopleIcon from '@material-ui/icons/People'
import PermIdentityIcon from '@material-ui/icons/PermIdentity'
import AccountBalanceIcon from '@material-ui/icons/AccountBalance'
import StorageIcon from '@material-ui/icons/Storage'
import ScatterPlotIcon from '@material-ui/icons/ScatterPlot'
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter'
import DescriptionIcon from '@material-ui/icons/Description'
import SearchIcon from '@material-ui/icons/Search'
import EventAvailableIcon from '@material-ui/icons/EventAvailable'
import ApartmentIcon from '@material-ui/icons/Apartment'
import SettingsIcon from '@material-ui/icons/Settings'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import AssignmentIcon from '@material-ui/icons/Assignment'
import BallotIcon from '@material-ui/icons/Ballot'
import AirlineSeatFlatIcon from '@material-ui/icons/AirlineSeatFlat'
import FaceIcon from '@material-ui/icons/Face'
import ReceiptIcon from '@material-ui/icons/Receipt'
import NoteIcon from '@material-ui/icons/Note'
import WorkIcon from '@material-ui/icons/Work'
import NextWeekIcon from '@material-ui/icons/NextWeek'
import TrackChangesIcon from '@material-ui/icons/TrackChanges'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import FingerprintIcon from '@material-ui/icons/Fingerprint'
import { DragIndicator, MoreHoriz } from '@material-ui/icons'
import constants from 'utils/constants'

export default [
  {
    title: '',
    pages: [
      {
        title: 'Dashboard',
        href: '/dashboard',
        permissao: constants.PERMISSOES.AUTENTICAR_USUARIO_LOCAL,
        icon: HomeIcon,
      },
      {
        title: 'Casos',
        permissao: constants.PERMISSOES.LISTAR_CASO,
        icon: BusinessCenterIcon,
        children: [
          {
            title: 'Cadastrar Caso',
            href: '/casos/cadastrar',
            permissao: constants.PERMISSOES.CADASTRAR_CASO,
            icon: AddCircleIcon,
          },

          {
            title: 'Meus Casos',
            permissao: constants.PERMISSOES.LISTAR_CASO,
            href: '/meuscasos',
            icon: WorkIcon,
          },
          {
            title: 'Casos do Setor',
            href: '/casosdosetor',
            permissao: constants.PERMISSOES.LISTAR_CASO,
            icon: NextWeekIcon,
          },
        ],
      },
      {
        title: 'Exames',
        permissao: constants.PERMISSOES.CADASTRAR_SOLICITACAO_EXAME,
        icon: DescriptionIcon,
        children: [
          {
            title: 'Meus Exames',
            permissao: constants.PERMISSOES.REALIZAR_EXAME,
            href: '/meusexames',
            icon: NoteIcon,
          },
          {
            title: 'Exames do Setor',
            permissao: constants.PERMISSOES.LISTAR_EXAME_SOLICITADO,
            href: '/examessolicitados/setor',
            icon: ReceiptIcon,
          },
        ],
      },
      {
        title: 'Vestígios',
        permissao: constants.PERMISSOES.CADASTRAR_SOLICITACAO_EXAME,
        icon: FingerprintIcon,
        children: [
          {
            title: 'Meus Vestígios',
            permissao: constants.PERMISSOES.CADASTRAR_VESTIGIO,
            href: '/vestigios/meusvestigios',
            icon: MoreHoriz,
          },
          {
            title: 'Vestígios no Setor',
            permissao: constants.PERMISSOES.CADASTRAR_VESTIGIO,
            href: '/vestigios/vestigiosdosetor',
            icon: DragIndicator,
          },
        ],
      },
      {
        title: 'Banco',
        permissao: constants.PERMISSOES.AUTENTICAR_USUARIO_LOCAL,
        icon: SearchIcon,
        children: [
          {
            title: 'Banco de Vestígios',
            permissao: constants.PERMISSOES.LISTAR_VESTIGIOS,
            href: '/vestigios',
            icon: BallotIcon,
          },
          {
            title: 'Banco de Exames',
            permissao: constants.PERMISSOES.LISTAR_EXAME_REALIZADO,
            href: '/bancodeexames',
            icon: AssignmentIcon,
          },
          {
            title: 'Banco de Cadáveres',
            permissao: constants.PERMISSOES.LISTAR_CADAVER,
            href: '/bancodecadaveres',
            icon: AirlineSeatFlatIcon,
          },
          {
            title: 'Banco de Periciandos',
            permissao: constants.PERMISSOES.LISTAR_CADAVER,
            href: '/bancodepericiando',
            icon: FaceIcon,
            
          },
        ],
      },
      {
        title: 'Requisições',
        permissao: constants.PERMISSOES.GERENCIAR_REQUISICOES, 
        href: '/requisicoes',
        icon: ReceiptIcon,
      },
      {
        title: 'Gerenciamento de Vagas',
        permissao: constants.PERMISSOES.GERENCIAR_VAGAS,
        href: '/gerenciamentodevagas',
        icon: EventAvailableIcon,
      },
      {
        title: 'Administração',
        href: '/dashboard',
        permissao: constants.PERMISSOES.ADMINISTRAR_SISTEMA,
        icon: SettingsIcon,
        children: [
          {
            title: 'Usuários',
            permissao: constants.PERMISSOES.ADMINISTRAR_SISTEMA,
            href: '/usuarios',
            icon: PeopleIcon,
          },
          {
            title: 'Cargos',
            permissao: constants.PERMISSOES.ADMINISTRAR_SISTEMA,
            href: '/cargos',
            icon: PermIdentityIcon,
          },
          {
            title: 'Orgãos',
            permissao: constants.PERMISSOES.ADMINISTRAR_SISTEMA,
            href: '/orgaos',
            icon: AccountBalanceIcon,
          },
          {
            title: 'Regionais PCI',
            permissao: constants.PERMISSOES.ADMINISTRAR_SISTEMA,
            icon: ApartmentIcon,
            children: [
              {
                title: 'Natal',
                permissao: constants.PERMISSOES.ADMINISTRAR_SISTEMA,
                href: '/orgaos/regionais/natal/divisoes',
                icon: ArrowRightIcon,
              },
              {
                title: 'Mossoró',
                permissao: constants.PERMISSOES.ADMINISTRAR_SISTEMA,
                href: '/orgaos/regionais/mossoro/divisoes',
                icon: ArrowRightIcon,
              },
              {
                title: 'Caicó',
                permissao: constants.PERMISSOES.ADMINISTRAR_SISTEMA,
                href: '/orgaos/regionais/caico/divisoes',
                icon: ArrowRightIcon,
              },
              {
                title: 'Pau dos Ferros',
                permissao: constants.PERMISSOES.ADMINISTRAR_SISTEMA,
                href: '/orgaos/regionais/paudosferros/divisoes',
                icon: ArrowRightIcon,
              },
            ],
          },
          {
            title: 'Tipos de Exames',
            permissao: constants.PERMISSOES.ADMINISTRAR_SISTEMA,
            href: '/exames',
            icon: ScatterPlotIcon,
          },
          {
            title: 'Gerenciamento da Balística',
            permissao: constants.PERMISSOES.ADMINISTRAR_SISTEMA,
            href: '/gerenciamentoBalistica',
            icon: TrackChangesIcon,
          },
          {
            title: 'Logs do servidor',
            permissao: constants.PERMISSOES.ADMINISTRAR_SISTEMA,
            href: '/logsservidor',
            icon: StorageIcon,
          },
        ],
      },
      {
        title: 'Central de Custódia',
        href: '/centraldecustodia',
        icon: AccountBalanceIcon,
      },
      {
        title: 'Gerenciamento de Usuários',
        permissao: constants.PERMISSOES.CADASTRAR_USUARIO,
        href: '/gerenciarusuarios',
        icon: PeopleIcon,
      },
    ],
  },
]
